// One build serves both products; the brand comes from the domain
// (qr.pdental.org / qr.pridge.net). Locally, set VUE_APP_BRAND=pridge in .env.local.
const host = window.location.hostname;
const key =
  process.env.VUE_APP_BRAND || (host.includes("pridge") ? "pridge" : "pdental");

const brands = {
  pdental: {
    key: "pdental",
    name: "PDental",
    apiBase: "https://api.pdental.org/api/",
    // apiBase: "https://api-test.pdental.org/api/",
    // apiBase: "https://localhost:44344/api/",
    primary: "#079ee4",
    logo: require("@/assets/logo.png"),
    favicon: "/favicon.webp",
    homeVideo:
      "https://www.youtube.com/embed/Q8FKZiJM_uk?si=35ynZ-i4OoUJc4Kv?modestbranding=1&mute=1&showinfo=0&controls=1&autoplay=1",
    defaultClinicData: {
      clinicName: "PDental Dental Cloud Software",
      clinicImage:
        "https://files.pdental.org/CC1d6b2420-c291-4357-ae45-a167ad9e04e7/505c60a0-c3da-4925-8008-e143c594e329-PDental Customized for you.png",
      clinicAddress: "Cairo",
      clinicMobile: "+201554340563",
      facebookLink: "https://www.facebook.com/PDental.PentaCors",
      twitterLink: "https://x.com/PDental_Cloud",
      youTubeLink: "https://www.youtube.com/@pdental_pentacors",
      instagramLink: "https://www.instagram.com/pdental_pentacors/",
      tiktokLink: "https://www.tiktok.com/@pdental_cloud",
      snapchatLink: "https://www.snapchat.com/add/pdental_cloud",
      whatsappLink: "wa.me/201554340563",
      videoLink:
        "https://www.youtube.com/watch?v=Q8FKZiJM_uk&ab_channel=PDental",
    },
  },
  pridge: {
    key: "pridge",
    name: "Pridge",
    apiBase: "https://api.pridge.net/api/",
    // apiBase: "https://api-test.pridge.net/api/",
    primary: "#346F80",
    logo: require("@/assets/brands/pridge/logo.webp"),
    favicon: "/pridge/favicon.ico",
    homeVideo: null,
    defaultClinicData: {
      clinicName: "Pridge Dental Lab Cloud Software",
      clinicImage: null,
      clinicAddress: "Cairo",
      clinicMobile: "+201554340563",
      whatsappLink: "wa.me/201554340563",
    },
  },
};

const brand = brands[key] || brands.pdental;
brand.isPridge = brand.key === "pridge";

// Pridge pages read Pridge's own field names; only the shared Social bar
// (fed from FetchClinicData) needs youtubeLink under PDental's name.
brand.normalize = (data) => {
  if (!brand.isPridge || !data || typeof data !== "object" || Array.isArray(data)) return data;
  if (data.youtubeLink && !data.youTubeLink) return { ...data, youTubeLink: data.youtubeLink };
  return data;
};

export default brand;
